import React from 'react'
import { makeStyles } from '@material-ui/styles'
import { Distance, Location } from 'components/search/result-card'

const useStyles = makeStyles(theme => ({
  locationDistance: {
    display: 'flex',
    flexDirection: 'column',

    [theme.breakpoints.up('sm')]: {
      alignItems: 'center',
      flexDirection: 'row',
    },
  },
}))

export default function LocationDistance({ hit }) {
  const classes = useStyles()

  return (
    <div className={classes.locationDistance}>
      <Location hit={hit} />
      <Distance hit={hit} />
    </div>
  )
}
